import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./pages/unlogged/login'));
// const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {

  render() {
    const authToken = localStorage.getItem("token");
    return (
      // <HashRouter>
          <React.Suspense fallback={loading}>
            <BrowserRouter >
              <Switch>
                {!authToken 
                  ? <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
                  : <>
                      <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />
                      <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
                      <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
                    </>
                }
                {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} /> */}
              </Switch>
            </BrowserRouter>
          </React.Suspense>
      // </HashRouter>
    );
  }
}

export default App;
